import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';

const CurriculumTreeWrapper = styled.div((props) => {
    const { typography } = ThemeHelper.getTheme(props);

    return `
    font-family: ${typography.family};
    height: 100%;
    font-size: 14px;
    `;
});

export default CurriculumTreeWrapper;



// WEBPACK FOOTER //
// ./app/components/curriculum-tree/styled.js